import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { BootGate } from './components/layout/boot-gate';
import { ErrorBoundary } from './components/layout/error-boundary';
import { createStaticAuthPort, setAuthPort } from './data/auth';
import { config } from './data/config';
import './index.css';

/**
 * Composition root.
 *
 * No monorepo o boot era `renderApp` (Keycloak → Router → Intl → Profile →
 * ErrorBoundary → Suspense → App + Toast) importado de
 * `@nasajon/erprompt-bootstrap`. Aqui ele é explícito e local, e a única
 * dependência externa de autenticação é o `keycloak-js` — o mesmo cliente OIDC
 * que aqueles pacotes envolviam.
 *
 * Dois caminhos, decididos por `VITE_PAN_DATA_SOURCE`:
 *
 *  - `rest` (padrão): `BootGate` autentica no Keycloak, descobre no Diretório a
 *    que instalações a pessoa tem acesso e só então monta a aplicação.
 *  - `demo`: porta de autenticação estática e dados de exemplo — para trabalhar
 *    em tela sem login nem backend.
 */


if (config.dataSource === 'demo') {
  setAuthPort(createStaticAuthPort('', { nome: 'Sessão de demonstração', detalhe: 'Dados de exemplo' }));
}

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root não encontrado no index.html.');

const aplicacao = (
  <BrowserRouter basename={config.basePath}>
    <App />
  </BrowserRouter>
);

createRoot(raiz).render(
  <StrictMode>
    <ErrorBoundary>
      {config.dataSource === 'demo' ? aplicacao : <BootGate>{aplicacao}</BootGate>}
    </ErrorBoundary>
  </StrictMode>,
);
